import Title from '@/components/ui/Title'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'

const ThreeD = () => {
  return (
    <div className="py-4 px-8 flex flex-col gap-8">
      <Title className="w-full text-center" text="3D Work" />
      <p className="text-3xl md:px-16 leading-12">
        I started my 3D modelling journey in Maya in 2021, and quickly found a
        passion for it. My work in Maya led me to learn ZBrush, which allowed me
        to explore and expand into more organic modelling. I love the
        flexibility and intuitive nature of ZBrush, and I have been refining my
        skills in the software, especially in application to character design
        and development. I have made several characters that I have gone on to
        rig and animate for projects, and optimising these models and mesh has
        become an area I am familiar with. Models that I create in Maya and
        Zbrush are exported to Adobe Substance Painter for texturing and
        detailing, and then usually finally imported and rendered in Unreal
        Engine.
      </p>
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
        <Masonry>
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/2d-to-3d.webp"
            alt="2d-to-3d"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/ANI181-1.webp"
            alt="ANI181-1.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/ANI181-2.webp"
            alt="ANI181-2.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/cafe1.webp"
            alt="cafe1.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/cafe2.webp"
            alt="cafe2.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/cafe3.webp"
            alt="cafe3.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/croissant.webp"
            alt="croissant.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/deer.webp"
            alt="deer.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/hair1.webp"
            alt="hair1.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/hair2.webp"
            alt="hair2.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/macron.webp"
            alt="macron.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/mushroom-house1.webp"
            alt="mushroom-house1.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/mushroom-house2.webp"
            alt="mushroom-house2.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/mushroom1.webp"
            alt="mushroom1.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/mushroom2.webp"
            alt="mushroom2.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/oven1.webp"
            alt="oven1.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/oven2.webp"
            alt="oven2.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/3DWork/soldier.webp"
            alt="soldier.webp"
          />
        </Masonry>
      </ResponsiveMasonry>
    </div>
  )
}

export default ThreeD
